import React from "react";
import { Box, Chip, ColorPaletteProp } from "@mui/joy";

type StatusBadgeProps = {
  color?: ColorPaletteProp;
  children: React.ReactNode;
  sx?: any;
};

const StatusBadge = ({ color = "neutral", children, sx }: StatusBadgeProps) => {
  return (
    <Chip
      size="sm"
      variant="soft"
      color={color}

      sx={[
        {
          fontSize: "0.65rem",
          fontWeight: 600,
          letterSpacing: "0.02em",
          textTransform: "uppercase",
          borderRadius: "999px",
          minHeight: 18,
          py: 0.25,
          px: 0.75,
          maxWidth: "100%",
          whiteSpace: "normal",
          textAlign: "center",
        },
        ...(Array.isArray(sx) ? sx : [sx]),
      ]}
    >
      {children}
    </Chip>
  );
};

export default StatusBadge;
